var _rect, _rect2, _path, _circle, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMetabotSad = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 12,
  x: 1,
  y: 2,
  stroke: "currentColor",
  strokeWidth: 1.5,
  rx: 1.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 6.5,
  x: 3,
  y: 4,
  stroke: "currentColor",
  rx: 0.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.25,
  d: "M7.333 9H7c0-.59.35-1 1-1s1 .41 1 1h-.333c0-.333-.167-.667-.667-.667s-.667.334-.667.667Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 5.625,
  cy: 6.375,
  r: 0.875,
  fill: "currentColor"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.375,
  cy: 6.375,
  r: 0.875,
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  d: "M10.25 12h2"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMetabotSad);
export default ForwardRef;